import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Paper,
  Avatar
} from '@mui/material';
import {
  Security,
  Speed,
  Visibility,
  People,
  Favorite
} from '@mui/icons-material';
import styled from 'styled-components';

const Section = styled(Box)`
  padding: 4rem 0;
`;

const ValuePaper = styled(Paper)`
  padding: 2rem;
  height: 100%;
  text-align: center;
  transition: transform 0.2s;
  &:hover {
    transform: translateY(-4px);
  }
`;

const IconWrapper = styled(Avatar)`
  margin: 0 auto 1.5rem;
  background: ${({ theme }) => theme.palette.primary.main};
  width: 60px;
  height: 60px;
`;

const HeartIcon = styled(Favorite)`
  color: ${({ theme }) => theme.palette.primary.main};
  vertical-align: middle;
  margin: 0 4px;
  font-size: 1.2rem;
`;

const About: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Section>
        <Typography variant="h3" align="center" gutterBottom>
          About XCH.live
        </Typography>
        <Typography variant="h6" align="center" color="textSecondary" paragraph>
          Securing the Future of Chia Cold Storage
        </Typography>

        <Box mt={6}>
          <Typography variant="body1" paragraph>
            XCH.live is built with <HeartIcon /> by the Spacescan.io team to provide secure 24/7 
            monitoring of your cold wallets. Using just your public master key or XCH address, 
            you can sleep peacefully knowing our cloud monitoring system will alert you instantly 
            of any wallet activity - no private keys needed.
          </Typography>
        </Box>

        <Box mt={8}>
          <Typography variant="h4" align="center" gutterBottom>
            Our Core Values
          </Typography>
          <Grid container spacing={4} mt={2}>
            <Grid item xs={12} sm={6} md={3}>
              <ValuePaper elevation={2}>
                <IconWrapper>
                  <Security fontSize="large" />
                </IconWrapper>
                <Typography variant="h6" gutterBottom>
                  Security First
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  We prioritize the security of your assets above all else, never requiring access to private keys.
                </Typography>
              </ValuePaper>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <ValuePaper elevation={2}>
                <IconWrapper>
                  <Speed fontSize="large" />
                </IconWrapper>
                <Typography variant="h6" gutterBottom>
                  Real-Time Monitoring
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Instant notifications and updates about your wallet activity, 24/7.
                </Typography>
              </ValuePaper>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <ValuePaper elevation={2}>
                <IconWrapper>
                  <Visibility fontSize="large" />
                </IconWrapper>
                <Typography variant="h6" gutterBottom>
                  Transparency
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Clear, honest communication about our services and your wallet status.
                </Typography>
              </ValuePaper>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <ValuePaper elevation={2}>
                <IconWrapper>
                  <People fontSize="large" />
                </IconWrapper>
                <Typography variant="h6" gutterBottom>
                  Community Focus
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Built by and for the Chia community, with continuous feedback and improvements.
                </Typography>
              </ValuePaper>
            </Grid>
          </Grid>
        </Box>
      </Section>
    </Container>
  );
};

export default About; 